import { useTranslation } from "react-i18next";
import { ButtonTypes, SystemTypes } from "../../Definitions";
import { colors, fonts, glyphs, useMediaQuery } from "../../Styles";
import { NewButton } from "../BaseComponents";

interface ModalLayoutLvl1_props {
  onReset: () => void;
  leftContent: JSX.Element | JSX.Element[];
  leftContentMobileHeight: number;
  penLength: number;
  rightContent: JSX.Element;
  bottomContent: JSX.Element | JSX.Element[];
  systemType: SystemTypes
}

export default function ModalLayoutLvl1({onReset, leftContent, penLength, rightContent, bottomContent, leftContentMobileHeight, systemType}:ModalLayoutLvl1_props) {
  const { t } = useTranslation();
  const mobileXs = useMediaQuery(`(max-width: 805px)`);
  
  return (
    <div style={{ width: "100%", display: "grid", gridTemplateRows: mobileXs ? "20px 2px 1fr 2px 120px 2px" : "20px 2px 1fr 2px 76px 2px", gap: "5px", gridTemplateColumns: "1fr", height: "100%" }}>
      
      {/* Reset Btn */}
      <div style={{ gridArea: "1/1/2/2", display: "flex", alignItems: "end", justifyContent: "flex-end", padding: "0px 22px", boxSizing: "border-box"}}>
        <NewButton
          content={`${t("reset", {defaultValue: "reset"})}`}
          buttonType={ButtonTypes.textButton}
          endEnhancer={glyphs.ArrowReset({ size: "15px"})}
          onClick={() => onReset()}
        />
      </div> 

      {/* Seperator */}
      <div style={{ gridArea: "2/1/3/2",  borderBottom: "2px solid "+colors.blueDarkSecondary }} />

      <div style={{ gridArea: "3/1/4/2", gap: mobileXs ? "20px" : undefined, padding: "10px", height: "100%", maxHeight: "40vh", boxSizing: "border-box", overflowY: "auto", overflowX: "hidden", scrollbarWidth: "thin", scrollbarColor: colors.blueDarkSecondary + colors.transparent, display: "grid", gridTemplateColumns: mobileXs ? "1fr" : "350px 1fr", gridTemplateRows: mobileXs ? `${leftContentMobileHeight}px 1fr` : "1fr" }}>
        
        {/* Left Content */}
        <div style={{ gridArea: "1/1/2/2", display: "flex", flexDirection: "column", gap: "10px", alignItems: mobileXs ? "center" : undefined }}>
          {leftContent}
        </div>
      

        {/* Right Content */}
        <div style={{ gridArea: mobileXs ? "2/1/3/2" : "1/2/2/3", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "start", gap: "5px"}}>
          <div style={{display: "grid", gridTemplateColumns: "4fr 1fr", gap: "5px", position: "relative"}}>         
            <p style={{gridArea: "1/1/2/2", ...fonts.header, ...fonts.fontSize4, color: colors.greyLightTertiary }}>{`${
              systemType === SystemTypes.freedaLf ? t("locationFeederPages.sections.penAmount", { defaultValue: "Number of Pens" })
            : systemType === SystemTypes.freedaEsf_WalkThrough ? t("esfWalkThroughPages.newSection.stationAmount", { defaultValue: "Number of Stations" })  
            :undefined}:`}</p>
            <p style={{gridArea: "1/2/2/3", ...fonts.paragraph, ...fonts.fontSize4, color: colors.greyLightTertiary, textAlign: "right", lineHeight: "1"}}>{penLength}</p>
            { penLength === 0 ? <div style={{position: "absolute", right: "-25px", top: "-4px"}}><glyphs.Error fillColor={colors.systemRed} /></div> : <></>}
          </div>
            {rightContent}
          <p style={{ ...fonts.paragraph, ...fonts.fontSize4, color: colors.greyLightTertiary, textAlign: "center", whiteSpace: 'pre-wrap', maxWidth: "150px" }}>{
              systemType === SystemTypes.freedaLf ? t("locationFeederPages.sections.clickOnPen", { defaultValue: "Click on a pen to remove it or add it again." })
              : systemType === SystemTypes.freedaEsf_WalkThrough ? t("esfWalkThroughPages.newSection.clickOnStation", { defaultValue: "Click on a station to add it or remove it again." })
                : undefined
          }</p>
        </div>

      </div>

      {/* Seperator */}
      <div style={{ gridArea: "4/1/5/2", borderBottom: "2px solid "+colors.blueDarkSecondary }} />

      <div style={{ gridArea: "5/1/6/2", padding: "10px", boxSizing: "border-box", display: "flex", alignItems: "flex-start", justifyContent: "center", flexDirection: "column", gap: "10px", overflow: mobileXs ? "auto" : "hidden", scrollbarWidth: "thin", scrollbarColor: colors.blueDarkSecondary+colors.transparent }}>
        <p style={{ ...fonts.header, ...fonts.textShadow, ...fonts.fontSize4, color: colors.greyLightTertiary, padding: "0px 0px 0px 10px" }}>{
          systemType === SystemTypes.freedaLf ? t("locationFeederPages.sections.penContent", { defaultValue: "pen Content" })
            : systemType === SystemTypes.freedaEsf_WalkThrough ? t("esfWalkThroughPages.newSection.stationContent", { defaultValue: "station content" })
              : undefined
        }</p>
        <div style={{ width: "fit-content", display: "flex", flexWrap: "wrap", columnGap: mobileXs ? "10px" : "60px", rowGap: "10px", boxSizing: "border-box", margin: "0 auto", justifyContent: "center" }}>
          {bottomContent}
        </div>
      </div>
      
      {/* Seperator */}
      <div style={{ gridArea: "6/1/7/2", borderBottom: "2px solid " + colors.blueDarkSecondary }} />
      
    </div>
  )
}